import React from 'react';

const REdirectSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      color={color}
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6714 5.13153C12.7947 5.13153 12.9129 5.18049 13 5.26764L14.5491 6.81672C14.7306 6.99821 14.7306 7.29245 14.5491 7.47394C14.3676 7.65542 14.0734 7.65542 13.8919 7.47394L13.1362 6.71819V10.6308C13.1362 12.7765 11.8111 14 10.3478 14C8.8845 14 7.55947 12.7765 7.55947 10.6308V2.49809C7.55947 1.96968 7.34003 1.59446 7.01274 1.33987C6.67295 1.07557 6.19786 0.929443 5.70058 0.929447C5.2033 0.929451 4.72821 1.07558 4.38842 1.33989C4.06112 1.59449 3.84169 1.9697 3.84169 2.49809V5.44134H4.92604C5.43936 5.44134 5.85549 5.85747 5.85549 6.37079V9.08168C5.85549 9.595 5.43936 10.0111 4.92604 10.0111H1.82788C1.31457 10.0111 0.898438 9.595 0.898438 9.08168V6.37079C0.898438 5.85747 1.31457 5.44134 1.82788 5.44134H2.91224V2.49809C2.91224 1.67093 3.27371 1.02946 3.81776 0.606261C4.34933 0.192778 5.03605 5.35538e-06 5.70058 1.1159e-10C6.36511 -5.35516e-06 7.05183 0.192756 7.5834 0.606239C8.12746 1.02944 8.48892 1.67091 8.48892 2.49809V10.6308C8.48892 12.3577 9.48751 13.0706 10.3478 13.0706C11.2081 13.0706 12.2067 12.3577 12.2067 10.6308V6.71819L11.451 7.47394C11.2695 7.65542 10.9752 7.65542 10.7937 7.47394C10.6123 7.29245 10.6123 6.99821 10.7937 6.81672L12.3428 5.26764C12.43 5.18049 12.5482 5.13153 12.6714 5.13153ZM1.82788 9.08168V6.37079H4.92604V9.08168H1.82788Z"
        fill={color}
      />
    </svg>
  );
};

export default REdirectSVG;
